export enum StatusOrganization {
  ComingSoon = 'coming_soon',
  Open = 'open',
  ClosedPermanently = 'closed_permanently',
  ClosedSeason = 'closed_this_season'
}
